import React from 'react'
import { DataType, ColumnConfigType } from '../types/advanced-grid.types'

interface Props {
    columnName: string
    columnsConfig: ColumnConfigType[]
    rowData?: DataType
}

/**
 * This component renders a cell for the table content
 * @param param0
 * @author Alejandro Quiroz <alejandro.devop@gmail.com>
 * @version 1.0.0
 * @returns
 */
const CellRender: React.FC<Props> = ({ columnName, columnsConfig, rowData }) => {
    const columnConfig: ColumnConfigType = columnsConfig.find((item) =>
        typeof item === 'object' ? item.key === columnName : item === columnName
    ) || { key: columnName }
    let content: string | React.ReactNode = 'Cell content'
    let className: string = ''

    const resolveValue = (col: string) => {
        const resolvedValue = col.split('.').reduce((currentValue, colName) => {
            if (typeof currentValue === 'object' && currentValue[colName]) {
                currentValue = currentValue[colName] || ''
            }
            return currentValue
        }, rowData || {})
        return resolvedValue
    }

    if (columnConfig && typeof columnConfig == 'object') {
        const { className: colClasses, value } = columnConfig
        className = colClasses || ''
        if (typeof value === 'function') {
            content = value(rowData) || ''
        } else if (typeof value === 'string') {
            if (value.includes('.')) {
                content = resolveValue(value)
            } else {
                content = value
            }
        } else {
            content = rowData ? rowData[columnName] : ''
        }
    }
    return <td className={className}>{content}</td>
}

export default CellRender
